<div class="flex gap-4">
    <input #searchBox
        type="text" 
        class="search-input border border-gray-300 rounded-md px-4 py-2 w-full" 
        (keydown.enter)="initSearch(searchBox.value)"
        [placeholder]="placeholder"/>
    <button 
        class="search-button border border-gray-300 text-gray-600 rounded-md px-4 py-2"
        (click)="initSearch(searchBox.value)">
        Search
    </button>
</div>
